module.exports = __webpack_public_path__ + "img/photo-0095.ef73d7ca.jpg";